/**
 * UGC Video Slider
 * Swiper coverflow + play/pause per video. No autoplay.
 */
(function() {
  'use strict';

  const UGCVideoSlider = {
    instances: [],

    init(selector) {
      const container = document.querySelector(selector);
      if (!container) return;

      const swiperEl = container.querySelector('[data-ugc-slider]');
      if (!swiperEl) return;

      const slides = swiperEl.querySelectorAll('.swiper-slide');
      if (slides.length === 0) return;

      // Swiper may not be loaded yet
      const initSwiper = () => {
        if (typeof Swiper === 'undefined') {
          setTimeout(initSwiper, 50);
          return;
        }

        const slideCount = parseInt(swiperEl.getAttribute('data-slide-count') || '0', 10);

        const swiper = new Swiper(swiperEl, {
          effect: 'coverflow',
          grabCursor: true,
          centeredSlides: true,
          slidesPerView: 'auto',
          coverflowEffect: {
            rotate: 0,
            stretch: 0,
            depth: 100,
            modifier: 2.5,
            slideShadows: false
          },
          navigation: {
            nextEl: swiperEl.querySelector('.swiper-button-next'),
            prevEl: swiperEl.querySelector('.swiper-button-prev')
          },
          loop: slideCount > 1,
          spaceBetween: 50
        });

        UGCVideoSlider.instances.push({ container, swiper });
      };

      initSwiper();

      // Play/pause handlers
      container.addEventListener('click', (e) => {
        const btn = e.target.closest('[data-video-toggle]');
        if (!btn) return;

        const slide = btn.closest('.swiper-slide');
        if (!slide) return;

        const video = slide.querySelector('.ugc-video-slider__video');
        if (!video) return;

        const iconPlay = btn.querySelector('.ugc-video-slider__icon-play');
        const iconPause = btn.querySelector('.ugc-video-slider__icon-pause');

        if (video.paused) {
          video.play();
          if (iconPlay) iconPlay.style.display = 'none';
          if (iconPause) iconPause.style.display = 'block';
          btn.setAttribute('aria-label', 'Pause video');
        } else {
          video.pause();
          if (iconPlay) iconPlay.style.display = 'block';
          if (iconPause) iconPause.style.display = 'none';
          btn.setAttribute('aria-label', 'Play video');
        }
      });

      // Pause all videos when slide changes (optional, for UX)
      slides.forEach((slide) => {
        const video = slide.querySelector('.ugc-video-slider__video');
        if (!video) return;

        video.addEventListener('pause', () => {
          const btn = slide.querySelector('[data-video-toggle]');
          const iconPlay = btn?.querySelector('.ugc-video-slider__icon-play');
          const iconPause = btn?.querySelector('.ugc-video-slider__icon-pause');
          if (iconPlay) iconPlay.style.display = 'block';
          if (iconPause) iconPause.style.display = 'none';
          if (btn) btn.setAttribute('aria-label', 'Play video');
        });
      });
    }
  };

  window.UGCVideoSlider = UGCVideoSlider;
})();
